import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks, siteBrand, siteTagline } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur-md'
          : 'border-transparent bg-background-50/70 backdrop-blur-sm'
      }`}
    >
      <nav className="w-full px-4 md:px-8 xl:px-12" aria-label="主导航">
        <div className="flex h-16 items-center justify-between gap-4 md:h-20">
          <Link to="/" className="group flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-700 text-background-50">
              <i className="ri-archive-2-fill text-xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
                {siteBrand}
              </span>
              <span className="hidden text-[11px] tracking-[0.28em] text-foreground-500 sm:block">
                {siteTagline}
              </span>
            </span>
          </Link>

          <div className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-800'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <Link
              to="/topics"
              className="hidden whitespace-nowrap rounded-md bg-primary-700 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-800 md:inline-flex"
            >
              浏览秘史专题
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="展开导航菜单"
              aria-expanded={open}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="animate-fade border-t border-background-200 pb-4 pt-3 lg:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <NavLink
                  key={link.path}
                  to={link.path}
                  className={({ isActive }) =>
                    `rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-800'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/topics"
                className="mt-2 inline-flex justify-center whitespace-nowrap rounded-md bg-primary-700 px-4 py-3 text-sm font-medium text-background-50"
              >
                浏览秘史专题
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}